import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Patients = () => {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  // Mock data for patients
  useEffect(() => {
    // Simulate loading patient data
    setTimeout(() => {
      setPatients([
        { id: 1, name: 'Maria Popescu', cnp: '1234567890123', phone: '+40 721 123 456', email: 'maria@example.com', lastVisit: '2025-01-15' },
        { id: 2, name: 'Andrei Vasile', cnp: '2345678901234', phone: '+40 722 234 567', email: 'andrei@example.com', lastVisit: '2025-01-10' },
        { id: 3, name: 'Ioana Radu', cnp: '3456789012345', phone: '+40 723 345 678', email: 'ioana@example.com', lastVisit: '2025-01-08' },
        { id: 4, name: 'George Matei', cnp: '4567890123456', phone: '+40 724 456 789', email: 'george@example.com', lastVisit: '2025-01-05' },
        { id: 5, name: 'Elena Dumitrescu', cnp: '5678901234567', phone: '+40 725 567 890', email: 'elena@example.com', lastVisit: '2025-01-03' }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredPatients = patients.filter(patient =>
    patient.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    patient.cnp.includes(searchTerm) ||
    patient.phone.includes(searchTerm)
  );

  return (
    <div className="patients-page">
      <div className="page-navigation-header">
        <div className="nav-header-content">
          <NavLink to="/dashboard" className="back-to-dashboard">
            ← Înapoi la Dashboard
          </NavLink>
          <div className="quick-nav">
            <NavLink to="/appointments" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Programări
            </NavLink>
            <NavLink to="/doctors" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Doctori
            </NavLink>
            <NavLink to="/reports" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
              Rapoarte
            </NavLink>
          </div>
        </div>
      </div>

      <div className="page-header">
        <h1>Administrare Pacienți</h1>
        <p>Gestionați informațiile pacienților și înregistrările medicale</p>
      </div>

      <div className="page-controls">
        <div className="search-section">
          <input
            type="text"
            placeholder="Caută după nume, CNP sau telefon..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <button className="add-patient-btn">Adaugă Pacient Nou</button>
      </div>

      <div className="patients-stats">
        <div className="stat-card">
          <h3>Total Pacienți</h3>
          <div className="stat-number">{patients.length}</div>
        </div>
        <div className="stat-card">
          <h3>Pacienți Activi</h3>
          <div className="stat-number">{patients.filter(p => new Date(p.lastVisit) > new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)).length}</div>
        </div>
        <div className="stat-card">
          <h3>Programări Astăzi</h3>
          <div className="stat-number">12</div>
        </div>
      </div>

      <div className="patients-table-container">
        {loading ? (
          <div className="loading">Se încarcă lista pacienților...</div>
        ) : (
          <table className="patients-table">
            <thead>
              <tr>
                <th>Nume</th>
                <th>CNP</th>
                <th>Telefon</th>
                <th>Email</th>
                <th>Ultima Vizită</th>
                <th>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {filteredPatients.map(patient => (
                <tr key={patient.id}>
                  <td>{patient.name}</td>
                  <td>{patient.cnp}</td>
                  <td>{patient.phone}</td>
                  <td>{patient.email}</td>
                  <td>{new Date(patient.lastVisit).toLocaleDateString('ro-RO')}</td>
                  <td>
                    <button className="view-btn">Vezi Detalii</button>
                    <button className="edit-btn">Editează</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <style jsx>{`
        .patients-page {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
        }

        .page-navigation-header {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 2rem;
          padding: 1rem;
        }

        .nav-header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .back-to-dashboard {
          color: #667eea;
          text-decoration: none;
          font-weight: 500;
          padding: 0.5rem 1rem;
          border-radius: 4px;
          transition: background 0.3s;
        }

        .back-to-dashboard:hover {
          background: #f8f9fa;
        }

        .quick-nav {
          display: flex;
          gap: 1rem;
        }

        .quick-nav-link {
          padding: 0.5rem 1rem;
          color: #666;
          text-decoration: none;
          border-radius: 4px;
          font-weight: 500;
          transition: all 0.3s;
        }

        .quick-nav-link:hover, .quick-nav-link.active {
          background: #667eea;
          color: white;
        }

        .page-header {
          margin-bottom: 2rem;
        }

        .page-header h1 {
          color: #333;
          margin-bottom: 0.5rem;
        }

        .page-header p {
          color: #666;
        }

        .page-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          gap: 1rem;
        }

        .search-section {
          flex: 1;
        }

        .search-input {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 1rem;
        }

        .add-patient-btn {
          padding: 0.75rem 1.5rem;
          background: #667eea;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 500;
          transition: background 0.3s;
        }

        .add-patient-btn:hover {
          background: #5a67d8;
        }

        .patients-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .stat-card {
          background: white;
          padding: 1.5rem;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          border-left: 4px solid #667eea;
        }

        .stat-card h3 {
          margin: 0 0 0.5rem 0;
          color: #666;
          font-size: 0.9rem;
          text-transform: uppercase;
          font-weight: 600;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: bold;
          color: #333;
        }

        .patients-table-container {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          overflow: hidden;
        }

        .loading {
          text-align: center;
          padding: 3rem;
          color: #666;
        }

        .patients-table {
          width: 100%;
          border-collapse: collapse;
        }

        .patients-table th,
        .patients-table td {
          padding: 1rem;
          text-align: left;
          border-bottom: 1px solid #f0f0f0;
        }

        .patients-table th {
          background: #f8f9fa;
          font-weight: 600;
          color: #333;
        }

        .patients-table tbody tr:hover {
          background: #f8f9fa;
        }

        .view-btn,
        .edit-btn {
          padding: 0.5rem 1rem;
          margin-right: 0.5rem;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 500;
          transition: background 0.3s;
        }

        .view-btn {
          background: #28a745;
          color: white;
        }

        .view-btn:hover {
          background: #218838;
        }

        .edit-btn {
          background: #ffc107;
          color: #212529;
        }

        .edit-btn:hover {
          background: #e0a800;
        }
      `}</style>
    </div>
  );
};

export default Patients;
